import React from 'react';
import {Outlet} from "react-router-dom";
import {AuthService} from "../../service/AuthService";
import {Forbidden} from "../../components/Forbidden";

export const User = () => {
  return (
    <>
      { !AuthService.hasRole('ROLE_USER') && (
        <Forbidden module="user"/>
      )}
      { AuthService.hasRole('ROLE_USER') && (
        <Outlet/>
      )}
    </>
  );
}
